module.exports = __webpack_public_path__ + "media/images/av-icon-white-7497a5647a02c152c3362240120a3245.png";